<div class="sharesHeaders__relationships" data-testid="relationships-toggle" ppTooltip [ppTitle]="ppDisabled ? disabledTooltipText : ''">
  <pp-toggle
    [ppDisabled]="ppDisabled"
    [ppChecked]="editPermission"
    (ppAction)="changeEditPermission()"
    ppStyle="blue"
  ></pp-toggle>
</div>
